import React, { useMemo } from 'react';

import { UNUSED_EMPLOYMENT_STATUSES } from '@/modules/employee/employee.constants';

import useGeneralInfoStore from '../GeneralInfo/stores/useGeneralInfo.store';

import CurrentStatus from './CurrentStatus';
import EmploymentStatuses from './EmploymentStatuses';
import Wrapper from './Wrapper';

const EmploymentStatusTimeline = () => {
  const { employmentStatuses } = useGeneralInfoStore((state) => state.state);
  const currentStatusType = useGeneralInfoStore((state) => state.sourceState?.status);
  const statuses = useMemo(() => {
    let hasActive = false;

    const displayedStatuses = employmentStatuses?.filter(
      (item) => !item.status || !UNUSED_EMPLOYMENT_STATUSES.includes(item.status),
    );

    const statusesWithOnlyOneActive = displayedStatuses?.map((item) => {
      if (item.isActive && item.status !== currentStatusType) {
        return { ...item, isActive: false };
      }

      if (item.isActive && item.status === currentStatusType && !hasActive) {
        hasActive = true;
        return item;
      }

      if (hasActive && item.isActive) {
        return { ...item, isActive: false };
      }

      return item;
    });

    return statusesWithOnlyOneActive;
  }, [employmentStatuses, currentStatusType]);

  if (!statuses?.length) return null;

  const isCurrentStatusDisplayed = !currentStatusType || !UNUSED_EMPLOYMENT_STATUSES.includes(currentStatusType);

  return (
    <Wrapper
      currentStatus={isCurrentStatusDisplayed ? <CurrentStatus type={currentStatusType} /> : null}
    >
      <EmploymentStatuses statuses={statuses} />
    </Wrapper>
  );
};

export default EmploymentStatusTimeline;
